// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/styles/font/Montserrat/Montserrat-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/styles/font/Noto_Sans_SC/NotoSansSC-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Montserrat';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}
@font-face {
  font-family: 'Noto Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}
html,
body {
  margin: 0;
  font-family: 'Noto Sans', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
code {
  font-family: 'Noto Sans', 'Montserrat', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;AACJ;AAEA;EACI,wBAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;AAAJ;AAGA;;EACI,SAAA;EACA,oMAAA;EAEA,mCAAA;EACA,kCAAA;AADJ;AAIA;EACI,qHAAA;AAFJ","sourcesContent":["@font-face {\n    font-family: 'Montserrat';\n    src: url('@/styles/font/Montserrat/Montserrat-VariableFont_wght.ttf') format('truetype');\n    font-weight: 100 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Noto Sans';\n    src: url('@/styles/font/Noto_Sans_SC/NotoSansSC-VariableFont_wght.ttf') format('truetype');\n    font-weight: 100 900;\n    font-style: normal;\n}\n\nhtml, body {\n    margin: 0;\n    font-family: 'Noto Sans', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: 'Noto Sans', 'Montserrat', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
